import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';

import { Footer } from './IFooter';
import { CommonService } from '../services/common.service';

import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CacheService } from "../../shared/services/cache.service";

@Component({
    selector: 'app-footer',
    templateUrl: '../templates/template1/views/app-footer.component.html',
    styleUrls: ['../templates/template1/themes/default/CSS/app-footer.less'],
    encapsulation: ViewEncapsulation.None
})
export class AppFooterComponent implements OnInit {

    @Input() placeHolderId: string;
    @Input() customerType: string;
    public footerData: Footer[];
    private countryName: any;
    errorMessage: any = [];
    contenthtml: any;
    currentYear: number;

   constructor(private _commonService: CommonService, 
    private _cacheService:CacheService) { }

    ngOnInit() {
        this.currentYear = (new Date()).getFullYear();
        this.countryName = this._cacheService.get(CacheKey.CountryName);
       // this.getFooterData();
    }

    //To get footer data from cms
    // getFooterData() {
    //     if (this.placeHolderId != undefined) {
    //         this._commonService.getFooterData(this.placeHolderId, this.countryName)
    //             .subscribe(response => {
    //                 this.footerData = response,
    //                 this.contenthtml =  this.footerData.find((x:any)=>x.customer == this.customerType)
    //                                     .footerPreference.find((y:any)=>y.country == this.countryName).htmlcontent           
    //             },
    //             error => this.errorMessage = <any>error)
    //     }
    // }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/app-footer.component.ts